import { QueryRequestHelper } from '@common/query-request-helper';
import { formatText, sortByProperty } from '@common/text-helpers';
import { getAllCurrency } from '@services/currency.service';
import { getAllCustomers } from '@services/customers.service';
import { getAllDepartments } from '@services/departments.service';
import { getAllExpenseCategories } from '@services/expense-category.service';
import { getAllExpenseReports } from '@services/expense-reports.service';
import { getAllExpenseTypes } from '@services/expense-type.service';
import { getAllGL } from '@services/gl.service';
import {
  getlistManagementGroupItem,
  getlocationManagementStates,
  listManagementByGroupcode,
  listManagementByGroupName,
  locationManagementSearchCities,
  locationManagementSearchCountries,
} from '@services/list-management.service';
import { getAllPaidThroughAccount, getAllPaidThroughAccountAdmin } from '@services/paid-through-accounts.service';
import { getAllPolicies } from '@services/policy.service';
import { getAllProjects } from '@services/projects.service';
import { getAllRoles } from '@services/roles.service';
import { getAllAirports, getAllTrips } from '@services/trips.service';
import { getAllCommonUsers } from '@services/users.service';
import { getValue } from '@utils/lodash';

export const baseCurrencySearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    status: 'active',
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllCurrency(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value:
                getValue(item, `currency_symbol`, '') +
                ' ' +
                getValue(item, `currency_code`, ''),
              label:
                getValue(item, `currency_symbol`, '') +
                ' ' +
                getValue(item, `currency_code`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const currencySearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    status: 'active',
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllCurrency(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ''),
              label:
                getValue(item, `currency_symbol`, '') +
                ' ' +
                getValue(item, `currency_code`, ''),
            }))
          : [];

      return sortByProperty(data);
    }
  } catch (error) {}
};

export const usersSearchableDropdown = async (
  id: string | string[],
  search_text: string,
  apply_delegated_to?: number | null,
  approval_delegated_to?: number,
  travel_document_delegated_to?: number,
  travel_profile_delegated_to?: number,
) => {
  const payload: any = {
    page_no: 1,
    page_size: 10,
    is_active: true,
  };

  if (search_text) {
    payload.search_text = search_text;
  }

  if (Array.isArray(id)) {
    payload.user_ids = id?.join(',');
    payload.page_size = id?.length;
  } else if (id) {
    payload.id = id;
  }

  if (apply_delegated_to) {
    payload.apply_delegated_to = apply_delegated_to;
  }

  if (approval_delegated_to) {
    payload.approval_delegated_to = approval_delegated_to;
  }

  if (travel_document_delegated_to) {
    payload.travel_document_delegated_to = travel_document_delegated_to;
  }

  if (travel_profile_delegated_to) {
    payload.travel_profile_delegated_to = travel_profile_delegated_to;
  }

  let queryRequest = QueryRequestHelper(payload);
  try {
    let resp = await getAllCommonUsers(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.users.length`, 0) > 0
          ? getValue(resp, `data.users`, []).map((item: object) => ({
              ...item,
              value: `${getValue(item, `first_name`, '')}${' '}${getValue(
                item,
                `last_name`,
                '',
              )}${' '}${' '}(${getValue(item, `email`, '')})`,
              label: `${getValue(item, `first_name`, '')}${' '}${getValue(
                item,
                `last_name`,
                '',
              )}${' '}${' '}(${getValue(item, `email`, '')})`,
              workflow_name: `${getValue(
                item,
                `first_name`,
                '',
              )}${' '}${getValue(item, `last_name`, '')}`,
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const usersSearchableDropdownForDelegation = async (
  id: string | string[],
  search_text: string,
  delegated_to?: number,
) => {
  const payload: any = {
    page_no: 1,
    page_size: 10,
    is_active: true,
  };

  if (search_text) {
    payload.search_text = search_text;
  }

  if (Array.isArray(id)) {
    payload.user_ids = id?.join(',');
    payload.page_size = id?.length;
  } else if (id) {
    payload.id = id;
  }

  if (delegated_to) {
    payload.delegated_to = delegated_to;
  }

  let queryRequest = QueryRequestHelper(payload);
  try {
    let resp = await getAllCommonUsers(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.users.length`, 0) > 0
          ? getValue(resp, `data.users`, []).map((item: object) => ({
              ...item,
              value: String(getValue(item, `id`, '')), // THIS IS THE KEY CHANGE
              label: `${getValue(item, `first_name`, '')} ${getValue(
                item,
                `last_name`,
                '',
              )} (${getValue(item, `email`, '')})`,
              workflow_name: `${getValue(item, `first_name`, '')} ${getValue(
                item,
                `last_name`,
                '',
              )}`,
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const usersByIDSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    is_active: true,
    id: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllCommonUsers(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.users.length`, 0) > 0
          ? getValue(resp, `data.users`, []).map((item: object) => ({
              ...item,
              value: `${getValue(item, `id`, '')}`,
              label: `${getValue(item, `first_name`, '')}${' '}${getValue(
                item,
                `last_name`,
                '',
              )}${' '}${' '}(${getValue(item, `email`, '')})`,
              id: `${getValue(item, `id`, '')}`,
              workflow_name: `${getValue(
                item,
                `first_name`,
                '',
              )}${' '}${getValue(item, `last_name`, '')}${' '}${' '}(${getValue(
                item,
                `email`,
                '',
              )})`,
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const customersSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllCustomers(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `contact_display_name`, ''),
              label: getValue(item, `contact_display_name`, ''),
              workflow_name: getValue(item, `contact_display_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const rolesSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 100,
    is_active: true,
    ids: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllRoles(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.roles.length`, 0) > 0
          ? getValue(resp, `data.roles`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `title`, ''),
              label: getValue(item, `title`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const departmentsSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    status: 'active',
    id: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllDepartments(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.departments.length`, 0) > 0
          ? getValue(resp, `data.departments`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `department_name`, ''),
              label: getValue(item, `department_name`, ''),
              workflow_name: getValue(item, `department_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const departmentsHeadSearchableDropdown = async (
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    is_active: true,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllDepartments(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.departments.length`, 0) > 0
          ? getValue(resp, `data.departments`, []).map((item: object) => ({
              ...item,
              label: `${getValue(
                item,
                `department_name`,
                '',
              )}${' - '}${getValue(
                item,
                `department_head.name`,
                '',
              )}${' '}${' '}(${getValue(item, `department_head.email`, '')})`,
              value: getValue(item, `id`, ''),
              id: getValue(item, `id`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const expenseTypeSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 50,
    enable_policy: true,
    id: search_text ? '' : id,
    status: 'active',
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllExpenseTypes(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `expense_type_name`, '')),
              label: getValue(item, `expense_type_name`, ''),
              workflow_name: getValue(item, `expense_type_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const expenseReportsSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    filter_type: 'list',
    approval_status: 'unsubmitted',
    is_active: true,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllExpenseReports(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.expense_reports.length`, 0) > 0
          ? getValue(resp, `data.expense_reports`, []).map((item: object) => ({
              ...item,
              value:
                formatText(getValue(item, `report_name`, '')) +
                ' - ' +
                getValue(item, `report_id`, ''),
              label:
                formatText(getValue(item, `report_name`, '')) +
                ' - ' +
                getValue(item, `report_id`, ''),
              workflow_name: getValue(item, `report_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const expenseTripSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    filter_type: 'expense_report',
    is_active: true,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllTrips(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.length`, 0) > 0
          ? getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              value:
                formatText(getValue(item, `trip_name`, '')) +
                ' - ' +
                getValue(item, `trip_id`, ''),
              label:
                formatText(getValue(item, `trip_name`, '')) +
                ' - ' +
                getValue(item, `trip_id`, ''),
              workflow_name: getValue(item, `trip_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};
export const expenseReportsSubmittedSearchableDropdown = async (
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    filter_type: 'list',
    // approval_status: "unsubmitted",
    is_unsubmitted: true,
    is_active: true,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllExpenseReports(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.expense_reports.length`, 0) > 0
          ? getValue(resp, `data.expense_reports`, []).map((item: object) => ({
              ...item,
              value:
                formatText(getValue(item, `report_name`, '')) +
                ' - ' +
                getValue(item, `report_id`, ''),
              label: getValue(item, `report_name`, ''),
              //  +" - " +
              // getValue(item, `report_id`, "")
              //   (getValue(item, `report_name`, "") + "\n" + getValue(item, `report_id`, "")), // For plain text rendering
              workflow_name: getValue(item, `report_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const expenseCategorySearchableDropdown = async (
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    is_active: true,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllExpenseCategories(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `category_name`, '')),
              label: getValue(item, `category_name`, ''),
              workflow_name: getValue(item, `category_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const paidThroughSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    status: 'active',
    id: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllPaidThroughAccount(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `account_name`, '')),
              label: getValue(item, `account_name`, ''),
              workflow_name: getValue(item, `account_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const paidThroughAdminSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    status: 'active',
    id: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllPaidThroughAccountAdmin(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `account_name`, '')),
              label: getValue(item, `account_name`, ''),
              workflow_name: getValue(item, `account_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const policieshSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    is_active: true,
    id: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllPolicies(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `policy_name`, '')),
              label: getValue(item, `policy_name`, ''),
              workflow_name: getValue(item, `policy_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const projectsSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true,
    status: 'active',
    id: id,
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllProjects(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `project_name`, '')),
              label: getValue(item, `project_name`, ''),
              workflow_name: getValue(item, `project_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const glSearchableDropdown = async (
  id: string,
  search_text: string,
) => {
  const payload = {
    search_text,
    page_no: 1,
    page_size: 10,
    status: 'active',
    id,
  };
  const queryRequest = QueryRequestHelper(payload);
  try {
    const resp = await getAllGL(queryRequest);
    if (resp) {
      const data =
        getValue(resp, `data.data.length`, 0) > 0
          ? getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              value: formatText(getValue(item, `gl_code`, '')),
              label: getValue(item, `gl_name`, ''),
              workflow_name: getValue(item, `gl_name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const airportsSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getAllAirports(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.airport.length`, 0) > 0
          ? getValue(resp, `data.airport`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ''),
              label:
                ' ' +
                getValue(item, `id`, '') +
                ' - ' +
                formatText(getValue(item, `name`, '')),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const citiesSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await locationManagementSearchCities(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.cities.length`, 0) > 0
          ? getValue(resp, `data.cities`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ''),
              label: getValue(item, `name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const statesSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await getlocationManagementStates(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.states.length`, 0) > 0
          ? getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ''),
              label: getValue(item, `name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const designationsSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await listManagementByGroupcode('designation');
    if (resp) {
      let data =
        getValue(resp, `data.listItems.length`, 0) > 0
          ? getValue(resp, `data.listItems`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `id`, ''),
              value: getValue(item, `id`, ''),
              label: getValue(item, `text`, ''),
              workflow_name: getValue(item, `text`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const locationSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await listManagementByGroupcode('location');
    if (resp) {
      let data =
        getValue(resp, `data.listItems.length`, 0) > 0
          ? getValue(resp, `data.listItems`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `id`, ''),
              value: getValue(item, `id`, ''),
              label: getValue(item, `text`, ''),
              workflow_name: getValue(item, `text`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const destinationSearchableDropdown = async (search_text: string) => {
  let paylod = {
    search_text: search_text,
    page_no: 1,
    page_size: 10,
    // is_active:true
  };
  let queryRequest = QueryRequestHelper(paylod);
  try {
    let resp = await locationManagementSearchCountries(queryRequest);
    if (resp) {
      let data =
        getValue(resp, `data.countries.length`, 0) > 0
          ? getValue(resp, `data.countries`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ''),
              label: getValue(item, `name`, ''),
            }))
          : [];
      return sortByProperty(data);
    }
  } catch (error) {}
};

export const userDesignationSearchableDropdown = async (
  search_text: string,
) => {
  try {
    let resp = await getlistManagementGroupItem('1', '');
    if (resp) {
      let data =
        getValue(resp, `data.listItems.length`, 0) > 0
          ? getValue(resp, `data.listItems`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ''),
              label: getValue(item, `text`, ''),
              workflow_name: getValue(item, `text`, ''),
            }))
          : [];

      // Filter by search text if provided
      if (search_text) {
        data = data.filter((item: any) =>
          item.label.toLowerCase().includes(search_text.toLowerCase()),
        );
      }

      return sortByProperty(data);
    }
  } catch (error) {
    console.error('Error fetching user designation:', error);
    return [];
  }
};

export const listManagementByGroupNameSearchableDropdown = async (
  group_name: string,
  search_text: string,
) => {
  try {
    let resp = await listManagementByGroupName('User Location');
    if (resp) {
      let data =
        getValue(resp, `data.listItems.length`, 0) > 0
          ? getValue(resp, `data.listItems`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `id`, ''),
              value: getValue(item, `id`, ''),
              label: getValue(item, `text`, ''),
              workflow_name: getValue(item, `text`, ''),
            }))
          : [];

      // Filter by search text if provided
      if (search_text) {
        data = data.filter((item: any) =>
          item.label.toLowerCase().includes(search_text.toLowerCase()),
        );
      }

      return sortByProperty(data);
    }
    return [];
  } catch (error) {
    console.error('Error fetching list management data:', error);
    return [];
  }
};
